import { render, staticRenderFns } from "./VPaginator.vue?vue&type=template&id=6c58a744&scoped=true"
import script from "./VPaginator.vue?vue&type=script&lang=ts"
export * from "./VPaginator.vue?vue&type=script&lang=ts"
import style0 from "./VPaginator.vue?vue&type=style&index=0&id=6c58a744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c58a744",
  null
  
)

export default component.exports